import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getAndroidCallSettings, openAndroidCallSettings, nativePlatform } from '../../utils/nativeCall';
import { PORTAL_RINGTONE } from './portalRingtone';
import { useCall } from './CallProvider';

const buttonStyle = { padding: '10px 14px', border: 0, borderRadius: 999, background: '#f2f2f2', color: '#000', font: 'inherit', fontSize: 10, fontWeight: 700, cursor: 'pointer' };

export default function CallAlertsPanel() {
  const android = nativePlatform() === 'android';
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState(null);
  const [playing, setPlaying] = useState(false);
  const audio = useRef(null);
  const call = useCall()?.call;
  const refresh = useCallback(async () => {
    if (!android) return;
    try { setSettings(await getAndroidCallSettings()); setError(null); }
    catch { setError('Update Portal to enable the incoming-call screen.'); }
  }, [android]);
  useEffect(() => {
    refresh();
    window.addEventListener('focus', refresh); document.addEventListener('visibilitychange', refresh);
    return () => { window.removeEventListener('focus', refresh); document.removeEventListener('visibilitychange', refresh); };
  }, [refresh]);
  useEffect(() => { if (call) { audio.current?.pause(); setPlaying(false); } }, [call]);
  const open = async (section) => {
    try { await openAndroidCallSettings(section); }
    catch { setError('Open Android Settings → Apps → Portal to change call alerts.'); }
  };
  const preview = async () => {
    if (playing) { audio.current.pause(); setPlaying(false); return; }
    audio.current.currentTime = 0;
    try { await audio.current.play(); }
    catch { setError('Could not play the ringtone. Tap to try again.'); }
  };
  return <div data-testid="call-alerts-panel" style={{ borderTop: '1px solid #e5e7eb', paddingTop: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
    <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.12em' }}>CALLS · PORTAL RINGTONE</span>
    <audio ref={audio} src={PORTAL_RINGTONE} preload="none" data-testid="portal-ringtone-preview" onPlaying={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
    <button type="button" style={buttonStyle} disabled={!!call} onClick={preview}>{playing ? 'STOP PREVIEW' : 'PREVIEW RINGTONE'}</button>
    {android && settings && <>
      <span style={{ fontSize: 11, lineHeight: 1.6 }}>{!settings.notifications ? 'Allow incoming call alerts so Portal can ring.' : !settings.fullScreen ? 'Allow full-screen calls to show who’s calling when your phone is locked.' : 'Incoming calls can fill the lock screen. While unlocked, Android may show a call banner.'}</span>
      {!settings.notifications && <button type="button" style={buttonStyle} onClick={() => open('notifications')}>ENABLE CALL ALERTS</button>}
      {!settings.fullScreen && <button type="button" style={buttonStyle} onClick={() => open('fullScreen')}>ENABLE FULL-SCREEN CALLS</button>}
      {settings.notifications && settings.fullScreen && <button type="button" style={buttonStyle} onClick={() => open('notifications')}>CALL SOUND & SETTINGS</button>}
    </>}
    {error && <span role="status" style={{ fontSize: 11, lineHeight: 1.6 }}>{error}</span>}
  </div>;
}
